
<div class="modal-dialog" style="max-width: 500px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Log Defect</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body text-justify mx-4" style="font-size: 18px">
      <p class="mb-3 text-center">Our support model has changed</p>
      <p class="mb-3 text-center">Please log your defects or access requests using</p>
      <p class="mb-3 text-center" style="margin-top: -.5em;"><a href="{{ 'supportLink' | appSetting }}" target="_blank">{{ 'supportLink' | appSetting }}</a></p>
      <p class="text-center">When creating a request, make sure you select "Transition Management Central (TMC)" as the Asset.</p>
      <p class="text-center">When logging defect, please include URL, Project Name, Workflow step name and attach any screenshots.</p>
      <p class="text-muted text-center">We are looking to automate this feature in the future.</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
    </div>
  </div>
</div>